import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { PicklistService } from "../../services/administration/picklist/picklist.service";
import { LoggedUserService } from "../../services/common/logged-user.service";

export interface PicklistItem {
  id: string;
  text: string;
  fieldId: number;
  isOnPrem?: boolean;
}

@Component({
  selector: "app-picklist-select",
  templateUrl: "./picklist-select.component.html",
  styles: [
    `
      .required {
        color: red;
      }

      .invalid-field {
        border: 1px solid red;
      }
    `,
  ],
})
export class PicklistSelectComponent implements OnInit, OnChanges {
  @Input() fieldName!: string;
  @Input() css: string = "mb-2 mt-2";
  @Input() control!: FormControl;
  @Input() label!: string;
  @Input() placeholder: string = "Select Option";
  @Input() required: boolean = false;
  @Input() parentId: number = 0;
  @Input() sortAlphabetically: boolean = true;
  @Output() selectionChange: EventEmitter<PicklistItem> =
    new EventEmitter<PicklistItem>();

  items: PicklistItem[] = [];
  facilityId: number = 0;

  constructor(private pickListsService: PicklistService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.parentId && !changes.parentId.firstChange) {
      this.loadData();
    }
  }

  isInvalid(): boolean {
    if (!this.required) return false;

    const isEmptyValue =
      this.control.value === "-1" ||
      this.control.value === null ||
      this.control.value === "";
    const isValidationTriggered =
      this.control.touched || this.control.dirty || this.control.invalid;

    return isEmptyValue && isValidationTriggered;
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    if (this.parentId > 0) {
      this.pickListsService
        .getPicklistValuesByParent(this.parentId)
        .subscribe((data) => {
          if (data) {
            let items = data.map((x: any) => ({
              id: x.id.toString(),
              text: x.value,
              fieldId: x.pickListFieldId,
              isOnPrem: x.isOnPrem,
            }));

            if (this.sortAlphabetically) {
              items = items.sort((a, b) => a.text.localeCompare(b.text));
            }

            this.items = items;
          }
        });
    } else {
      if (this.fieldName) {
        this.pickListsService
          .getPicklistValuesByFieldName(this.fieldName)
          .subscribe((data) => {
            let items = data.map((x: any) => ({
              id: x.id.toString(),
              text: x.value,
              fieldId: x.pickListFieldId,
              isOnPrem: x.isOnPrem,
            }));

            if (this.sortAlphabetically) {
              items = items.sort((a, b) => a.text.localeCompare(b.text));
            }

            this.items = items;
          });
      }
    }

    this.control.valueChanges.subscribe((selectedId) => {
      const selectedItem = this.items.find((item) => item.id === selectedId);
      if (selectedItem) {
        this.selectionChange.emit(selectedItem);
      } else if (selectedId === "-1") {
        // Handle placeholder selection
        this.selectionChange.emit({
          id: "-1",
          text: this.placeholder,
          fieldId: 0,
          isOnPrem: null,
        });
      }
    });
  }
}
